export function generateCanonicalAddress(response) {
    const components = response.address_components;
    // Helper function to find component by type
    const findComponentByType = (preferredTypes) => {
        for (const type of preferredTypes) {
            const match = components.find((c) => c.types.includes(type));
            if (match)
                return match;
        }
        return undefined;
    };
    // Extract place (locality, sublocality, or city)
    const place = findComponentByType([
        'locality', // City
        'sublocality', // Neighborhood
        'sublocality_level_1', // Neighborhood variant
        'neighborhood', // Neighborhood explicit
        'administrative_area_level_3', // Municipality, Borough, Sub District
        'administrative_area_level_2', // County, District
    ])?.long_name;
    // Extract region (state, province, or administrative area)
    const region = findComponentByType(['administrative_area_level_1', 'administrative_area_level_2'])?.long_name;
    // Extract country
    const country = findComponentByType(['country'])?.long_name;
    // Build canonical address, filtering out undefined values
    const addressParts = [place, region, country].filter(Boolean);
    if (!addressParts.length) {
        // Fallback to formatted address if no components found
        return response.formatted_address;
    }
    // Probably a country only location
    if (components.length === 1) {
        return [...new Set(addressParts)].join(', ');
    }
    return addressParts.join(', ');
}
